import { Component, effect, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Location } from "@angular/common";
import { AwsAuthService } from 'src/app/services/aws-auth.service';
import { TranslationService } from 'src/app/services/translation.service';
import { LanguageService } from 'src/app/services/language.service';
import { environment } from 'src/environments/environment';
import { ProfileDetails } from '../interfaces/myStories.interface';
import { MyStoriesService } from 'src/app/modules/stories/services/my-stories.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-header', 
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  menuSelected = false;
  currentUser: any;
  showHeader: any = true;
  selectedCategory: string = '/explore'
  toggleHeader: any = environment.isEnabled;
  translationData = [];
  language = this.languageService.getLanguage();
  showMenu = false;
  selectedLang: any;
  showBottomMenu: boolean = false;
  screenWidth: any;
  isHeaderMin = false;
  isProfileClicked = false;
  videoplayed: any = 'false';
  featureFlags: any;
  isProd = environment.production;
  public showMyProfileLink: boolean = false;
  public showLoginLink: boolean = false;
  languageToDisplay: string = 'Deutsch';
  showLangPicker: boolean = false;
  secondLastUrlElement: string = '';
  profileInfo: ProfileDetails = <any>null;
  profileImage = "../../../../../assets/images/profile-fallback.png";
  isMyProfileVisible: boolean = false;
  isLanguageSelector: boolean = false;
  public isHeadingAvailable: boolean = false;
  public isMyStoriesVisible: boolean = false;
  public enableMyProfile: boolean = false;
  showLogout: boolean = false;
  showSmartAppBanner: boolean = true;

  constructor(private readonly router: Router,
    private readonly location: Location,
    private readonly awsAuth: AwsAuthService,
    private readonly translationService: TranslationService,
    private readonly languageService: LanguageService,
    private readonly _storiesService: MyStoriesService,
    private readonly renderer: Renderer2) {
    this.featureFlags = this.translationService.featureFlags;
    // This is done for CIAM related pages, where we have to show the header dynamic language.
    // This is set based on participant locale we get from API
    this.languageService.participantLocale.subscribe((locale: any) => {
      this.getUserSelectedLanguage(locale);
    });

    effect(() => {
      const openLangaugeSelector = this.languageService.getIsLanguageSelectionOpen();
      this.showBottomMenu = openLangaugeSelector;
    })
  }

  ngOnInit() {
    this.hideOrShowSmartBannerBasedOnRoute()
    this.language = this.languageService.getLanguage();
    const videoStatus = sessionStorage.getItem('videoplayed');
    if (videoStatus) {
      this.videoplayed = videoStatus;
    }
    if (this.videoplayed === 'true') {
      this.isHeaderMin = true;
    }
    this.handleFeatureFlags();
    this.handleProfileTabVisibilty()
    setTimeout(() => {
      this.isHeaderMin = true
          this.getUserSelectedLanguage(this.language);
    }, 3600);
  }

  public hideOrShowSmartBannerBasedOnRoute(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const data = this.getActiveRouteData();
      
      this.showSmartAppBanner = !data['hideSmartBanner'];
    });
  }

  private getActiveRouteData(): any {
    let route = this.router.routerState.snapshot.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.data || {};
  }

  handleProfileTabVisibilty() {
    this.awsAuth.isLoginSuccess?.subscribe((isLoggedIn: boolean) => {
      this.currentUser = isLoggedIn || this.awsAuth.getUserLoggedInStatus();
      if (this.currentUser) {
        this.showMyProfileHeaderOnLogin();
      } else {
        this.showMyProfileLink = false;
        this.showLoginLink = true;
      }
      const currentUrl = this.location.path();
      this.selectedCategory = currentUrl.includes('/stories') ? '/stories' : '/explore';
    });
  }

  public handleFeatureFlags() {
    this.isProd = this.featureFlags?.general?.tempProdFlag;
    this.isMyStoriesVisible = this.featureFlags?.circuitDetails.enableStories;
    this.enableMyProfile = this.featureFlags?.general.enableMyProfile;
    this.showSmartAppBanner = this.featureFlags?.general.enableSmartBanner;
    if (this.featureFlags?.general?.enableLanguageSelector) {
      this.isLanguageSelector = true;
    }
    if (this.featureFlags?.general.enableMyProfile) {
      this.isMyProfileVisible = true;
    }
    if (this.featureFlags?.circuitDetails.enableStories) {
      this.isHeadingAvailable = true;
    }
  }


  logout() {
    localStorage.removeItem('routeUrl');
    this.awsAuth.clearLocalStorageItems();
    this.awsAuth.manageLogoutResponse();
  }

  openLanguagePicker() {
    this.languageService.showLanguageSelectionPage(true);
  }

  showDropMenu() {
    this.showMenu = true;
  }

  vidEnded() {
    sessionStorage.setItem('videoplayed', 'true')
  }

  hideMenuInMobile() {
    this.screenWidth = window.innerWidth;
    if (this.screenWidth < 1024) {
      this.showMenu = false;
    }
  }

  hideDropMenu() {
    this.showMenu = false;
  }

  showDropDownInMobile() {
    this.languageService.setIsLanguageSelectionOpen(!this.showBottomMenu);
    if (this.showBottomMenu) {
      this.renderer.setStyle(document.body, 'overflow', 'hidden');
    } else {
      this.renderer.removeStyle(document.body, 'overflow');
    }
  }

  public openExploreModule(): void {
    this.router.navigateByUrl(`${this.language}/explore`);
  }

  public reloadPage(): void {
    window.location.reload();
  }

  /**
   * @description If user lang is english but broswer language diff and is part of our supported lang - that lang.
   * If user lang and and browser default is Engligh -> German
   * If lang is not supported - then 404
   * @param locale
   */
  public getUserSelectedLanguage(participantLang: string) {
    let urlLang = participantLang;
    const supportedLocales: any[] = this.translationService.supportedLanguagesForDisplay;
    const fullURL = window.location.href.split('/');
    const langIndex = fullURL.findIndex(part => this.languageService.checkIsValideLanguage(part));
    if (langIndex !== -1) {
      urlLang = fullURL[langIndex];
    }
    if (this.featureFlags?.general.enableLanguageSelector && supportedLocales.length) {
      this.languageToDisplay = supportedLocales.find((lang: { localeCode: string; }) => lang.localeCode === urlLang)?.localeDescription ?? 'English';
      this.selectedLang = urlLang;
      this.language = urlLang;
    }

  }

  triggerLogin() {
    localStorage.removeItem('currentCIAMUser');
    localStorage.removeItem('isLoggedIn')
    this.awsAuth.manageLoginResponse()
  }

  /**
   * @description Non-Prod:- Method to handle navigation to my stories page
   * We need to go to CIAM login page if user is not logged in
   * Upon logging in, I should be redirected to the same page I was last on
   * Prod:- Method to handle navigation to home page and no Login/Explore buttons visible to user
   */
  public handleMyStoriesNavigationClick(): void {
    this.isProd = this.featureFlags?.general?.tempProdFlag;
    this.showBottomMenu = false;
    switch (true) {
      case this.currentUser && this.isHeadingAvailable:
        this.router.navigateByUrl(`${this.language}/stories`);
        this.selectedCategory = '/stories';
        break;
      case !this.currentUser && this.isHeadingAvailable:
        localStorage.setItem('routeUrl', '/' + this.selectedLang + '/stories');
        this.triggerLogin();
        break;
      case this.isProd:
        this.router.navigateByUrl(`${this.language}/home`);
        break;
      case !this.currentUser && !this.isHeadingAvailable:
        this.router.navigateByUrl(`${this.language}/home`);
        break;
      default:
        this.router.navigateByUrl(`${this.language}/home`);
        break;
    }
  }

  /**
   * @description Method to show/hide my profile and login links in header
   * called either on login or on page load
   */
  public showMyProfileHeaderOnLogin(): void {
    if (!this.currentUser) {
      this.showMyProfileLink = false;
      this.showLoginLink = true;
    } else if (this.currentUser && this.isHeadingAvailable) {
      this._storiesService.getProfile().subscribe({
        next: (data: ProfileDetails) => {
          this._storiesService.ciamId = data.userId;
          this._storiesService.profileInfoResponse = data;
          this.profileInfo = data;
          this.profileImage = data.profileImageUrl;
          this.showMyProfileLink = true;
          this.showLoginLink = false;
        }, error: () => {
          this.showMyProfileLink = false;
          this.showLoginLink = false;
          this.showLogout = true
        }
      })
    }
  }

  profileClicked() {
    if (this.featureFlags?.general?.enableMyProfile)
      this.isProfileClicked = true;

  }
  cancelClicked(event: any) {
    if (event) {
      this.isProfileClicked = false
    }
  }

  public navigateToProviderPage(): void {
    this.router.navigate(['/' + this.selectedLang + '/provider']);
    this.showDropDownInMobile();
  }

  public navigateToPrivacyPage(): void {
    this.router.navigate(['/' + this.selectedLang + '/privacy']);
    this.showDropDownInMobile();
  }

}

